const initialState = {};

export default function(state = initialState) {
    return state;
}



// WEBPACK FOOTER //
// ./safeTrade/noOpReducer.js